//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UserCard from '~/components/UserCard.vue';
import StatisticsService from '~/services/Statistics';
import createFormData from '~/helpers/createFormData';
import setUserIdentifierIfNotExists from '~/helpers/setUserIdentifierIfNotExists';
import { STATISTIC_ACTIONS } from '@/constants/statistics';

export default {
    components: { UserCard },
    props: {
        page: { type: Object, required: true }
    },
    data() {
        return {
            likeSent: false,
            dislikeSent: false,
            STATISTIC_ACTIONS: STATISTIC_ACTIONS
        };
    },
    computed: {
    },
    methods: {
        getEncodedUrl() {
            return encodeURIComponent(`https://мойкредит.рф${ this.$route.fullPath }`);
        },
        async sendLike(action) {
            if (action === STATISTIC_ACTIONS.LIKE) {
                if (this.likeSent) {
                    return;
                }

                this.likeSent = true;
            }

            if (action === STATISTIC_ACTIONS.DISLIKE) {
                if (this.dislikeSent) {
                    return;
                }

                this.dislikeSent = true;
            }

            try {
                await StatisticsService.hit(createFormData({
                    sessionId: setUserIdentifierIfNotExists(this.$cookies),
                    action,
                    page: this.$route.fullPath
                }));
            } catch (err) {
                // silent fail
            }
        }
    }
};
